export default "__VITE_ASSET__bb881418__"